// PrivacyPolicy.tsx
import React from 'react';
import abraLogo from '../../assets/abra-logo.png';

export default function PrivacyPolicy() {
  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <h1 className="dashboard-title">
          <img src={abraLogo} alt="Abra Logo" className="logo" />
          Console
        </h1>
      </header>

      <div className="dashboard-content" style={{ maxWidth: '800px', margin: '2rem auto', padding: '2rem' }}>
        <h2 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Privacy Policy</h2>
        <p>Effective Date: Apr. 28, 2025</p>
        <p>Last Updated: Apr. 28, 2025</p>

        <h3>1. Information We Collect</h3>
        <ul style={{ paddingLeft: '1.5rem' }}>
          <li>Name and email address (Google or GitHub OAuth)</li>
          <li>Usage logs and project metadata</li>
          <li>Device/browser analytics</li>
        </ul>

        <h3>2. How We Collect It</h3>
        <p>Through authentication, activity logging, and cookies/analytics tools.</p>

        <h3>3. Third-Party Services</h3>
        <ul style={{ paddingLeft: '1.5rem' }}>
          <li>Supabase</li>
          <li>OpenAI</li>
          <li>Render and Vercel (hosting and analytics)</li>
        </ul>

        <h3>4. How We Use Your Data</h3>
        <p>To operate, secure, and improve the Service. To monitor API usage and respond to user requests.</p>

        <h3>5. Data Retention</h3>
        <p>We retain data as long as necessary to provide the Service and meet legal obligations. You can request deletion by contacting us.</p>

        <h3>6. Your Rights</h3>
        <p>You may request access, correction, or deletion of your data at hello@abra-actions.com.</p>

        <h3>7. Security</h3>
        <p>We use industry-standard protections, but no system is 100% secure.</p>

        <h3>8. Changes to This Policy</h3>
        <p>We may update this Privacy Policy. Changes will be posted on this page.</p>

        <p style={{ marginTop: '2rem', fontSize: '0.85rem', color: 'var(--text-muted)' }}>
          Contact: hello@abra-actions.com
        </p>
      </div>
    </div>
  );
}
